import styled from 'styled-components';
import { ImageUrl } from '../../utils/constants';

const BorderBottom = styled.div`
  width: 100%;
  height:2px;
  border-radius: 5px;
  background: ${({background, active}) => active ? background : '#F8F8F8'};
  margin-top:8px;
  ${'' /* border-bottom: ${({active, background}) => active ?`2px solid ${background}` : 'rgba(243, 122, 101, 1)'}; */}
`

const BottomCard  = styled.div`
  width: 100%;
  display: flex;
  border-radius: 0 0 6px 6px;
  background: white;
  flex-wrap: wrap;
  padding:16px;
  .title{
    font-family: Lato;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #184A61;
    width:100%;
    margin-bottom:8px;
    align-items:center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .date{
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #184A61;
    width:100%;
    align-items:center;
  }
`;

const ImageCard  = styled.div`
  width: 100%;
  height:${({height})=> height ? height : '250px'};
  cursor: pointer;
  div{
    width: 100%;
  height:${({height})=> height ? height : '250px'};
  cursor: pointer;
    >img{
    width:100%;
    height:100%;
    border-radius: 6px 6px 0 0;
  }

  }
  >img{
    width:100%;
    height:100%;
    border-radius: 6px 6px 0 0;
  }
  .background {
    position: relative;
    top: -250px;
    width: 100%;
    height: 250px;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px 6px 0px 0px;
    .getStarted{
      font-family: Lato;
      width: 200px;
      height: 40px;
      background:${({isBackgroundColor})=> isBackgroundColor ? isBackgroundColor : '#F37A65'};
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 6px;
      color: #FEFEFE;
      font-size: 16px;
      line-height:20px;
      .eye{
        margin-right: 8px;
      }
    }
  }
`;

const CardWrapper  = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 24px;
`;

const RecommendedContainer = styled.div`
// margin:15px 0px 30px 0px;
width:1248px;
.row{
  display:flex;
  justify-content:center;
  width:100%;
  margin:0;
  .col-1{
    background:white;
    border-radius: 6px 0 0 6px;
    width:534px;
    padding: 0 16px 0 20px;
    .type{
      display:flex;
      margin:20px;

    .type-text{
      border-radius: 6px;
      background: rgba(0, 92, 135, 0.60);
      color:#FFF;
      font-family: Rubik-Regular;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; 
      padding:5px 15px;
      text-transform:capitalize;
     }
    }

    .details{
      display:flex;
      flex-direction:column;
      justify-content:center;
      height:100%;
      .title{
        font-weight: 700;
        font-size: 32px;
        line-height: 52px;
        letter-spacing: 0%;
        vertical-align: middle;
        color:#184A61;
        font-family:"Lato"
      }
      .challengeType{
        width:100%;
        display:flex;
        margin-top:25px;
        .icon{
          height:24px;
          width:auto;
          display:flex;
          >img{
            width:100%;
            height:100%;
          }
        }
        .type{
          font-family: Rubik;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          text-align: center;
          color: #005c87;
          display:flex;
          align-items:center;
          margin:0;
          padding-left:10px;
        }
      }
      .description{
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0%;
        text-align: justify;
        color: #184A61;        
        margin: 15px 0 28px 0px;
        -webkit-line-clamp: 8;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box !important;
        overflow: hidden;
        >p{
          margin:0px;
        }
      }
      .titleWrapper{
        color:  #005C87;
        font-family: Rubik;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        margin: 12px 0px;
        -webkit-line-clamp: 8;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box !important;
        overflow: hidden;
        >div{
          color: #005C87;
          font-family: Rubik;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
          width:100%;
          margin: 16px 0;
          list-style-type: disc;
          display:flex;
          .bullet{
            font-size: 36px;
            color: #005C87;
            padding-right:8px;
          }
        }
      }
      .moving-btn{
        align-items:center;
        flex-shrink: 0;
        display:flex;
        button{
          width: 175px;
          height: 48px;
          border-radius: 4px;
          background: #F37A65;
          ${'' /* box-shadow: 0px 8px 24px 0px rgba(0, 92, 135, 0.50); */}
          color: #FEFEFE;
          text-align: center;
          font-family: Lato;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          border:none;
          flex-shrink: 0;
          display:flex;
          align-items: center;
          justify-content: center;
          .icon{
            margin-right:8px;
          }
        }
        .fav-icon{
          border-radius: 3px;
          background:  rgba(0, 92, 135, 0.05);
          padding:13px;
          margin-left:15px;
        }
      }
    }
  }

  .col-2{
    ${'' /* background:${({background})=> background ? `linear-gradient(90deg, #FFF 0%, rgba(255,255,255,0.00) 10%), url(${ImageUrl}/${background})` : 'red'}; */}
    background:${({background})=> background ? `linear-gradient(90deg, #FFF 0%, rgba(255, 255, 255, 0.00) 93.33%),url(${ImageUrl}/${background})` : 'red'};
    // linear-gradient(90deg,#FFF 0%,rgba(255,255,255,0.00) 93.33%),url(https://ddf0gygzuiev4.cloudfront.net/webinar-video-category-image/nsIahOJimbu.png)
    background-size : cover;
    background-repeat : no-repeat;
    width: 714px;
    height:450px;
    border-radius: 0px 6px 6px 0px;
    .pick{

      margin-right:16px;

      .title{
      color: #005C87;
      text-align: center;
      font-family: Rubik-Medium;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }

    }
  }

  .imageContainer{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 100%;
  }

  .imageWrapper{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;
    margin-right: 10px;
  }
}
`
const ChallengeHeader = styled.div`
  color: ${({color,newColor, colorValue}) =>colorValue?colorValue: color ? '#0D4270' : newColor ? '002f47' : '#484856'};
  font-size: ${({color,newColor}) => color ? '18px' : newColor ? '18px' : '24px'};
  line-height: ${({color,newColor}) => color ? '24px' : newColor ? '21px' : '36px'};
  font-family: Lato;
  margin: ${({color,newColor}) => color ? '0px 0px 25px 0px' : newColor ? '0px 0px 25px 0px' : '0'};
  width: 100%;
  /* white-space: nowrap; */
  text-overflow: clip;
  font-weight: 500;
  display:flex;
  font-weight: 700;
  .icon{
    margin-right:20px;
  }
`;

const FitnessDeviceCard = styled.div`
width:100%;
display:flex;
padding: 20px 16px 0px 16px;
flex-wrap:wrap;
background:rgba(254, 254, 254, 0.60);
margin-top:20px;
.heading{
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  color: #184A61;
  padding-bottom:24px;
  border-bottom: 1px solid #EFEFEF;
  width:100%;
}
.details{
  padding-top:20px;
  display:block;
  .title{
    display:flex;
    font-family: Lato;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 68px;
    color: #184A61;
    margin-bottom: 10px;
    width:100%;
    .subtitle{
      font-family: Lato;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 68px;
      color: #DCDCDC;
      margin-left:5px;
    }
  }
  .wrap-card{
    display:flex;
    width:100%;
    flex-wrap:wrap;
    .no-data{
      width:100%;
      display:flex;
      text-align: center;
      margin-bottom: 20px;
      color: rgb(24, 74, 97);
      font-size: 16px;
    }
    .device{
      width:425px;
      display:block;
      .device-name{
        width:100%;
        display:flex;
        align-items: center;
        margin-bottom:20px;
        .circle{
          width:8px;
          height:8px;
          background: ${({background}) => background ? background : '#F8F8F8'};
          border-radius:50%;
          display:flex;
          align-items:center;
          margin-right:8px;
        }
        .count{
          text-align: center;
          font-family: Lato;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
          color: #184A61;
          display:flex;
          align-items:center;
        } 
      }
    }
    .device-images{
      width:calc(100% - 425px);
      display:flex;
      .fitbit{
        position:relative;
        height:160px;
        width:160px;
        border-radius:50%;
        margin-top: 31px;
        margin-left: -34px;
        z-index:10;
        background:white;
        border: 1px solid #DCDCDC;
        >img{
          height:100%;
          width:100%;
          position: relative;
          border-radius: 50%;
        }
      }
      .garmin{
        position:relative;
        height:120px;
        width:120px;
        border-radius:50%;
        z-index: 10;
        margin-top: 115px;
        margin-left: -66px;
        background:white;
        border: 1px solid #DCDCDC;
        >img{
          height:100%;
          width:100%;
          position: relative;
          border-radius: 50%;
        }
      }
      .applewatch{
        position:relative;
        height:220px;
        width:220px;
        border-radius:50%;
        position: relative;
        margin-top: -48px;
        margin-left: -15px;
        background:white;
        border: 1px solid #DCDCDC;
        >img{
          height:100%;
          width:100%;
          position: relative;
          border-radius: 50%;
        }
      }
      .health{
        position:relative;
        height:240px;
        width:240px;
        border-radius:50%;
        margin-top: -50px;
        margin-left: -34px;
        background:white;
        border: 1px solid #DCDCDC;
        >img{
          height:100%;
          width:100%;
          position: relative;
          border-radius: 50%;
        }
      }
      .googlefit{
        position:relative;
        height:200px;
        width:200px;
        border-radius:50%;
        margin-top: -15px;
        margin-left: -35px;
        position: relative;
        z-index: 8;
        background:white;
        border: 1px solid #DCDCDC;
        >img{
            height:100%;
            width:100%;
            position: relative;
            border-radius: 50%;
        }
      }
    }
  }
}
`;

const WeeksMain = styled.div`
width:100%;
display:flex;
padding:20px 0;
background: rgba(254,254,254,0.60);
.week{
  width:20%;
  display:flex;
  justify-content:center;
    align-items:center;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #184A61
}

`;

const KeyInsightWrapper = styled.div`
width:100%;
display:flex;
gap:24px;
.divSize{
  width:400px;
  display: flex;
}
.divSpotlight{
  width:614px;
  display: flex;
}
`;

const InsightCard = styled.div`
width:100%;
background: #FFF;
${'' /* display:flex; */}
padding:16px;
border-radius:4px;
${'' /* flex-wrap:wrap; */}
flex-direction: ${({direction}) => direction ? direction : ''};
.border-top{
  width:100%;
  margin: 20px 0;
  height:1px;
  background: #EFEFEF;
}
.header{
  width:100%;
  display: flex;
  .icon{
    
    width:48px;
    height:48px;
    border-radius:50%;
    margin-right:12px;
    background: ${({background}) => background ? background : '#F8F8F8'};
    display: flex;
    align-items:center;
    justify-content:center;
    >img{
      width:24px;
      height:24px;
      align-items: center;
      margin: auto;
    }
  }
  .text{
    color:#184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
    display:flex;
    align-items:center;
  }
  .endDiv{
    display:flex;
    margin: auto 0 auto auto;
    cursor:pointer;
  }
}
.headers-title{
  width:100%;
  padding:4px;
  display:flex;
  background: #F8F8F8;
  height:28px;
  margin-bottom:20px;
  .name{
    // width:206px;
    display:flex;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    align-items: center;
    margin: auto auto auto 0;
  }
  .activity{
    width:86px;
    display:flex;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-left: auto 0 auto auto;
    align-items: center;
  }
  .wellness{
    width:102px;
    display:flex;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-left: 45px;
    align-items: center;
  }
  .total{
    width:65px;
    display:flex;
    color: #184A61;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    justify-content: flex-end;
    margin-left: 30px;
    align-items: center;
  }
}
.wrapper{
  width:100%;
  display: flex;
  flex-wrap:wrap;
  margin: ${({margin}) => margin ? margin : 'auto'};
  height: ${({height}) => height ? height : ''};
  padding-right: ${({padding}) => padding ? padding : ''};
  flex-direction: ${({direction}) => direction ? direction : 'column'};
  overflow-x: ${({ showAllRows }) => (showAllRows ? "auto" : "hidden")};
    .no-data{
      margin-top: 20px;
      color: rgb(24, 74, 97);
      font-size: 16px;
      display: flex;
      align-items: center;
      font-family: Lato;
      margin:0px;
    }
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #ffffff;
    border-radius: 4px;
  }
  .no-data{
    width:100%;
    display:block;
    >img{
      display: flex;
      justify-content: center;
      margin: auto;
    }
    .comingSoon{
      color:  #184A61;
      text-align: center;
      font-family: Lato;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;
    }
  }
  .card-insight{
    width:100%;
    display:flex;
    justify-content:space-between;
    .title{
      color: #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
    .value{
      color: #184A61;
      text-align: right;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; /* 125% */
    }
  }
  .line{
    width:100%;
    margin: 22px 0;
    height:1px;
    background: #EFEFEF;
  }
  .border{
    width:100%;
    margin: 8px 0 !important;
    height:1px;
    background: #EFEFEF !important;
    border: none !important;
  }
  .card-spotlight{
    width:100%;
    display:flex;
    .profile{
      width:48px;
      height:48px;
      border-radius:50%;
      margin-right:8px;
      >img{
        width:48px;
        height:48px;
        border-radius:50%;
      }
    }
    .name{
      color: #184A61;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      // width:150px;
      display:flex;
      justify-content: flex-start;
      align-items: center;
    }
    .activity{
      color: #184A61;
      text-align: right;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width:85px;
      display:flex;
      justify-content: center;
      margin: auto 0 auto auto;
      align-items: center;
    }
    .behavior{
      color: #184A61;
      text-align: right;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width:102px;
      display:flex;
      justify-content: center;
      margin-left: 45px;
      align-items: center;
    }
    .total{
      color: #184A61;
      text-align: right;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width:65px;
      display:flex;
      justify-content: flex-end;
      margin-left: 30px;
      align-items: center;
    }

  }
}

.noData{
      display:flex;
      width:100%;
      flex-wrap:wrap;
      .image{
        width:100%;
        height:100%;
        display:flex;
        margin:auto;
        margin-top:70px;
        justify-content:center;
        >img{
          width:auto;
          height:132px;
        }
      }
      .empty{
        color: #184A61;
text-align: center;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; 
        display:flex;
        width:100%;
        justify-content:center;
        margin-top:15px;
        padding: 0px 70px;
        margin-bottom: 12px;
      }
    }
`;

const SeeMoreButton = styled.div`
width:100%;
display:flex;
color: #184A61;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
padding: 14px 16px;
cursor:pointer;
`;

const NochallengeCard = styled.div`
width: 100%;
display:flex;
background:#FEFEFE;
border-radius:4px;
padding: 12px 120px;
margin-top: 20px;
.image{
  width:196px;
  height:148px;
  >img{
      width:100%;
      height:100%;
  }
}
.details{
  display:block;
  padding-left:72px;
  .title{
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-top:8px;
    display:flex;
    align-items:center;
  }
  .subtext{
    color: #184A61;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-top:8px;
  }
  .button{
    margin-top:20px;
    width:200px;
    >button{
      width:100%;
    }
  }
}
`;

export {
  BorderBottom, BottomCard, ImageCard, CardWrapper, RecommendedContainer, ChallengeHeader, FitnessDeviceCard, WeeksMain, KeyInsightWrapper, InsightCard, SeeMoreButton, NochallengeCard
};
